import { gql } from "@apollo/client";
import AutopilotCuratedLinkedinSalesNavigatorSearchContext, {
  AutopilotCuratedLinkedinSalesNavigatorSearchContext_LinkedinSalesNavigatorFilters,
} from "../../../../contexts/AutopilotCuratedLinkedinSalesNavigatorSearchContext";
import {
  CuratedSearchDesignLsnFiltersStep_AutopilotSearchDesignLsnFiltersStepFragment,
  LinkedinSalesNavigatorFilters,
} from "../../../../__generated__/graphql";
import CuratedLinkedinSalesNavigatorSearchFiltersCard from "../../CuratedSearchFilters/CuratedLinkedinSalesNavigatorSearchFiltersCard";
import { useContext, useState } from "react";

export const CuratedSearchDesignLsnFiltersStep_AutopilotSearchDesignLsnFiltersStep = gql`
  fragment CuratedSearchDesignLsnFiltersStep_AutopilotSearchDesignLsnFiltersStep on AutopilotSearchDesignLsnFiltersStep {
    lsnFiltersData {
      filters {
        ...AutopilotCuratedLinkedinSalesNavigatorSearchContext_LinkedinSalesNavigatorFilters
      }
      additionalFiltering
    }
  }

  ${AutopilotCuratedLinkedinSalesNavigatorSearchContext_LinkedinSalesNavigatorFilters}
`;

const CuratedSearchDesignLsnFiltersStep = ({
  data,
}: {
  data: CuratedSearchDesignLsnFiltersStep_AutopilotSearchDesignLsnFiltersStepFragment;
}) => {
  const [currentFilters, setCurrentFilters] =
    useState<LinkedinSalesNavigatorFilters>(data.lsnFiltersData.filters);
  const [additionalFiltering, setAdditionalFiltering] = useState<string[]>(
    data.lsnFiltersData.additionalFiltering ?? [],
  );

  const { onSaveFilters } = useContext(
    AutopilotCuratedLinkedinSalesNavigatorSearchContext,
  );

  return (
    <CuratedLinkedinSalesNavigatorSearchFiltersCard
      currentFilters={currentFilters}
      setCurrentFilters={setCurrentFilters}
      additionalFiltering={additionalFiltering}
      setAdditionalFiltering={setAdditionalFiltering}
      onSave={async () => {
        await onSaveFilters({
          currentFilters,
          additionalFiltering,
        });
      }}
    />
  );
};

export default CuratedSearchDesignLsnFiltersStep;
